export const pricingPlans = [
  {
    id: 'free',
    name: 'Starter',
    description: 'Perfect for independent sellers closing occasional high-ticket jobs.',
    monthlyPrice: 0,
    annualPrice: 0,
    features: [
      'Unlimited Financing Quotes',
      'Stripe Connect Onboarding',
      'Standard Payment Processing',
      'QR Code & Link Checkout',
      'Email Support'
    ],
    cta: 'Start Free',
    popular: false,
    highlight: false,
  },
  {
    id: 'pro',
    name: 'Growth',
    description: 'For studios and agencies processing volume.',
    monthlyPrice: 29,
    annualPrice: 290, // $24.16/mo effective
    features: [
      'Everything in Starter',
      'Lower Platform Fees (0.5%)',
      'Custom Branded Checkout',
      'Priority Support',
      'Team Access (up to 5 seats)'
    ],
    cta: 'Start 7-Day Free Trial',
    popular: true,
    highlight: true,
  },
];

export const pricingFaqs = [
  {
    question: "How does the financing work?",
    answer: "We partner with Stripe to offer Klarna, Afterpay, and Affirm. Your customer selects their preferred payment plan at checkout, and you get paid the full amount upfront (minus standard processing fees)."
  },
  {
    question: "What are the platform fees?",
    answer: "On the Starter plan, we charge a 1% application fee per transaction on top of Stripe's standard processing fees. On the Growth plan, this drops to 0.5%."
  },
  {
    question: "Do I need a Stripe account?",
    answer: "Yes. We guide you through creating a Stripe Express account during onboarding. It takes about 5 minutes and handles all KYC and payouts."
  },
  {
    question: "Is this available outside the US?",
    answer: "Currently, LendLifted supports sellers in the United States. We are expanding to Canada and the UK soon."
  }
];
